<template>
  <div id="app">
    <el-container>
      <el-header v-if="$route.meta.menuShow" height="120px">{{ systemName }}</el-header>
      <el-main v-if="$route.meta.menuShow">
        <keep-alive>
          <router-view />
        </keep-alive>
      </el-main>
      <el-footer v-if="$route.meta.menuShow">
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
          style="text-decoration: none; color: #333333"
          >晋ICP备19013226号-1</a
        >
        <br />Copyright © 2005-2024 ChuanRen All rights reserved.
      </el-footer>
      <keep-alive v-if="!$route.meta.menuShow">
        <router-view />
      </keep-alive>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      systemName: "山西传人科技在线报名系统",
    };
  },
  mounted() {
    let routeKey = "";
    let currentDomain = window.location.hostname;
    //根据域名判断rk值
    if (currentDomain.indexOf("sypxzx") > -1) {
      routeKey = "syyp";
      //写入缓存中
      sessionStorage.setItem("routeKey", routeKey);
    } else {
      //查询url中的单位编号信息
      routeKey = this.$route.query.rk;
      if (routeKey) {
        //写入缓存中
        sessionStorage.setItem("routeKey", routeKey);
      } else {
        //查询缓存中
        routeKey = sessionStorage.getItem("routeKey");
      }
    }
    //判断路由参数赋值系统名称
    switch (routeKey) {
      case "lf":
        this.systemName = "临汾市在线报名管理系统";
        break;
      case "jzzy":
        this.systemName = "晋中职院在线报名管理系统";
        break;
      case "syyp":
        this.systemName = "寿阳县应急管理事务服务中心在线报名管理系统";
        break;
      default:
        break;
    }
  },
};
</script>

<style>
.el-header {
  background-image: url("./assets/headbg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #ddd;
  font-size: 24px;
  letter-spacing: 6px;
  line-height: 120px;
  padding-left: 30px;
}

.el-footer {
  font-size: 14px;
  color: #333;
  text-align: center;
  line-height: 28px;
  margin-top: 30px;
}

.el-main {
  background-color: #e9eef3;
  color: #333;
  text-align: center;
  min-height: 400px;
}

body > .el-container {
  margin-bottom: 40px;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background-color: #99a9bf;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  background-color: #d3dce6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue